import React from 'react';
import CountryInfoIcon from '../../../icons/CountryInfo';
import capitalizeFirstLetter from '@stencil/flights-utils/src/capitalize-first-letter';

const TopBannerSection = ({ destination, cityRef, countryRef, countryTravelGuidelines }) => {
  return (
    <>
      <div className="dF alignItemsCenter ">
        <div className="marginL10">
          <p className="font16 f500" style={{ color: '#FFFFFF' }}>
            {destination && destination?.toCity && cityRef && cityRef[destination.toCity]},{' '}
            {destination.toCountry && countryRef && countryRef[destination?.toCountry]}
          </p>
          {destination.covid_status && destination?.covid_status !== 'null' ? (
            destination?.covid_status === 'PARTIALLYOPEN' ? (
              <p className="font10 f500" style={{ color: '#FFFFFF' }}>
                Partially open for Indian tourists
              </p>
            ) : (
              <p className="font10 f500" style={{ color: '#FFFFFF' }}>
                {capitalizeFirstLetter(destination?.covid_status)} for Indian tourists
              </p>
            )
          ) : (
            ''
          )}
        </div>
      </div>
      {countryTravelGuidelines &&
      destination &&
      destination.toCountry &&
      countryTravelGuidelines[destination?.toCountry] ? (
        <span>
          <CountryInfoIcon
            width="1.6rem"
            height="1.6rem"
            fill="#fff"
            onClick={() => {
              window.open(countryTravelGuidelines[destination?.toCountry], '_blank');
            }}
          />
        </span>
      ) : null}
    </>
  );
};
export default TopBannerSection;
